module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6r8n7r-921845651b32f65932ab38fd81cf904a.svg";